(($, Drupal, drupalSettings) => {
  Drupal.behaviors.custom_social_share = {
    attach(context) {
      const shareButtons = once(
        "custom_social_share",
        ".custom_social_share",
        context
      );
      shareButtons.forEach((share) => {
        const shareButton = share.querySelector("button");
        // This should always be the case, but to remove any errors.
        if (shareButton && navigator.canShare) {
          share.classList.remove("hidden");
          shareButton.addEventListener("click", async () => {
            try {
              const shareData = {
                title: shareButton.getAttribute("share-title"),
                text: shareButton.getAttribute("share-description"),
                url: shareButton.getAttribute("share-path"),
              };
              await navigator.share(shareData);
            } catch (err) {
              // eslint-ignore no-empty
            }
          });
        }
      });
    },
  };
})(jQuery, Drupal, drupalSettings);
